<template>
  <div class="utility-page-wrap">
    <div class="utility-page-content w-clearfix w-form">
      <div class="state-img">
        <NotFoundToothIcon />
      </div>
      <h1 class="h1">Ой, кажется такой страницы не существует</h1>
      <div class="text-secondary">Возможно вы ввели некорректно ссылку или страница теперь находится по другому адресу</div>
      <div class="btn-wrap mt-16">
        <router-link
          :to="{name: 'orders'}"
          class="btn-primary w-inline-block"
        >
          <div>к Списку заказов</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import NotFoundToothIcon from '@/icons/not-found-tooth.svg';

  export default {
    name: 'Error404',
    components: {
      NotFoundToothIcon,
    },
  };
</script>
